import React, { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from "@material-ui/core/CircularProgress";

import 'index.css';
import 'components/GeolocInfo.scss';
import Context from 'utils/Context';


const GeolocInfo = () => {
    const { appState, methods, geoloc } = useContext(Context);
    const { ready, updatingGeoloc } = appState;

    const isOpen = ready && !geoloc;

    const { t } = useTranslation();
    return (
        <Dialog open={isOpen} scroll="body" className="my-dialog geoloc-info">
            <DialogTitle>
                {t('bienvenue-dans-votre-salle-virtuelle')}
            </DialogTitle>
            <DialogContent>
                <p>{t('nous-ne-pouvons-determiner-votre-position-precisemment')}</p>
                <p>{t('pour-une-meilleure-geolocalisation')}</p>
                <p>- {t('veillez-a-autoriser-la-geolocalisation-de-votre-navigateur')}</p>
                <p>- {t('veillez-a-activer-la-geolocalisation-dans-vos-parametres-systeme')}</p>
                <p>- <Trans i18nKey="la-geolocalisation-fonctionne-mieux-via"> <strong> </strong> </Trans></p>
            </DialogContent>
            <DialogActions>
                {!updatingGeoloc && <Button onClick={methods.refreshGeoloc} variant="contained" color="primary">
                    {t('mettre-a-jour-ma-geolocalisation')}
                </Button>}
                {updatingGeoloc && <Button
                    color="default"
                    disabled
                    variant="contained">
                    <CircularProgress size="20px" /> &nbsp; {t('mettre-a-jour-ma-geolocalisation')}
                </Button>}
            </DialogActions>

        </Dialog>
    );
};

export default GeolocInfo;
